<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useDetectDevice } from '@/composables/device'

import WarehouseMovementsView from '@/components/planner/WarehouseMovementsView.vue'
import WarehousesGrid from '@/components/planner/WarehousesGrid.vue'

const { isMobile } = useDetectDevice()
const route = useRoute()

const projectId = computed(() => (route.query.project ? Number(route.query.project) : null))
const warehouseId = computed(() => (route.query.warehouse ? Number(route.query.warehouse) : null))
</script>

<template>
  <warehouse-movements-view
    v-if="isMobile"
    :project="projectId"
    :warehouse="warehouseId"
  />
  <warehouses-grid v-else />
</template>
